import { cn } from '@/utils/classname';
import { SVGProps } from 'react';
import { fill, stroke } from './classNames';

export const FilesIcon = ({
  isActive,
  className,
  ...props
}: { isActive: boolean } & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn('group', className)}
    >
      <svg
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_303_16378)">
          <path
            className={fill(isActive)}
            d="M1 6.51114V3.45682C1.0015 2.98712 1.19001 2.53709 1.52437 2.20496C1.85874 1.87282 2.3118 1.68557 2.78466 1.68408H9.20681C9.67966 1.68557 10.1327 1.87282 10.4671 2.20496C10.8015 2.53709 10.99 2.98712 10.9915 3.45682V4.68759H16.8118C17.3917 4.68908 17.9474 4.91856 18.3574 5.32586C18.7675 5.73317 18.9985 6.28516 19 6.86117V15.4615C18.9985 16.1908 18.7066 16.8898 18.188 17.406C17.6694 17.9222 16.9662 18.2136 16.2321 18.2166H3.7736C3.03892 18.2136 2.3352 17.9224 1.8157 17.4064C1.2962 16.8903 1.00299 16.1913 1 15.4615V6.51114Z"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.68"
          />
          <path
            className={stroke(isActive)}
            d="M19 8H1"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.68"
          />
        </g>
        <defs>
          <clipPath id="clip0_303_16378">
            <rect fill="white" height="20" width="20" />
          </clipPath>
        </defs>
      </svg>
    </svg>
  );
};
